/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Drawer, Stack } from "@mui/material";
import ReleaseInfo from "@/src/components/ReleaseInfo/ReleaseInfo";
import React, { ReactNode, useRef } from "react";
import Footer from "@/src/components/Footer/Footer";
import AuthenticatedNavigation from "@/src/components/Navigation/AuthenticatedNavigation/AuthenticatedNavigation";
import Container, { ContainerProps } from "@/src/components/Container/Container";
import SkipLink from "@/src/components/SkipLink/SkipLink";
import ScrollTopButton from "@/src/components/Button/ScrollTopButton";
import { layoutProtectedRoutesStyle } from "@/src/containers/Layouts/layoutProtectedRoutesStyle";
import NavigationBar from "@/src/components/Navigation/NavigationBar/NavigationBar";
import { mergeSx } from "@/src/utils/mergeSx";

export type LayoutProtectedRoutesProps = {
  children: ReactNode;
  sidebar?: boolean;
  containerVariant?: ContainerProps["variant"];
};

export default function LayoutProtectedRoutes({ children, sidebar = true, containerVariant = "md" }: LayoutProtectedRoutesProps) {
  const skipLinkRef = useRef<HTMLAnchorElement>(null);

  return (
    <>
      <ReleaseInfo />
      <SkipLink ref={skipLinkRef} />
      <NavigationBar />
      <Stack direction={"row"}>
        {sidebar && (
          <Drawer
            variant={"permanent"}
            sx={mergeSx({ width: "21rem" }, layoutProtectedRoutesStyle.sidebar)}
            slotProps={{
              paper: {
                sx: {
                  width: "21rem",
                },
              },
            }}
          >
            <AuthenticatedNavigation sx={layoutProtectedRoutesStyle.navigation} />
          </Drawer>
        )}
        <Box sx={layoutProtectedRoutesStyle.pageContainer}>
          <Box component={"main"} id={"main-content"} sx={layoutProtectedRoutesStyle.childrenContainer}>
            <Container variant={containerVariant}>{children}</Container>
          </Box>
          <ScrollTopButton skipLinkRef={skipLinkRef} />
          <Footer />
        </Box>
      </Stack>
    </>
  );
}
